import $ from 'jQuery';
import { debounce } from '../utils/functions';

const dms = element => {
    bindToggleDms(element);
    bindFilter(element);
};

const bindFilter = element => {
    element.off('input');
    element.on(
        'input',
        'input[name="folder-filter-search"]',
        debounce(function () {
            const keyWord = String($(this).val()).replace(/\s/g, '').toLowerCase();

            if (keyWord) {
                const $items = element.find('.dms__title');
                const matchingKeyWords = [];

                $items.each(function () {
                    const kw = $(this).html().replace(/\s/g, '').toLowerCase();
                    kw.includes(keyWord) && matchingKeyWords.push(kw);
                });

                $items
                    .closest('.dms__item')
                    .data('hidden', true)
                    .hide(0, () => {
                        if (matchingKeyWords.length) {
                            const process = matchingKeyWords.reduce((promiseChain, kw) => {
                                return promiseChain.then(
                                    () =>
                                        new Promise(resolve => {
                                            const $mathingElements = element
                                                .find('.dms__title')
                                                .filter(function () {
                                                    return (
                                                        $(this)
                                                            .html()
                                                            .replace(/\s/g, '')
                                                            .toLowerCase() == kw
                                                    );
                                                })
                                                .closest('.dms__item')
                                                .data('hidden', false);

                                            const $mathingElementsNotInTree =
                                                $mathingElements.filter(function () {
                                                    return (
                                                        $(this).closest('.dms-toggle').length == 0
                                                    );
                                                });

                                            if ($mathingElementsNotInTree.length) {
                                                $mathingElementsNotInTree.show(0, () => resolve());
                                            } else {
                                                resolve();
                                            }
                                        })
                                );
                            }, Promise.resolve());

                            process.then(() => {
                                const $dmsToggles = element
                                    .find('.dms__item')
                                    .filter(function () {
                                        const $thisEl = $(this);
                                        return (
                                            $thisEl.data('hidden') === false &&
                                            !$thisEl.hasClass('dms-toggle')
                                        );
                                    })
                                    .parents('.dms-toggle');

                                $dmsToggles.trigger('click', [true]);
                            });
                        }
                    });
            } else {
                element
                    .find('.dms__title')
                    .closest('.dms__item')
                    .data('hidden', false)
                    .filter(function () {
                        return (
                            $(this)
                                .closest('.dms-toggle')
                                .filter(function () {
                                    return !$(this).hasClass('active');
                                }).length == 0
                        );
                    })
                    .show();
            }
        })
    );
    element.off('click');
    element.on('click', "button[name='remove-folder-filter']", function () {
        const $input = element.find('input[name="folder-filter-search"]');
        $input.val('').trigger('input');
    });
};

const bindToggleDms = element => {
    const $dmsToggle = element.find('.dms-toggle');

    $dmsToggle.off('click');
    $dmsToggle.on('click', toggleDms);
};

function toggleDms(e, onlyShow) {
    e.stopPropagation();

    const $thisEl = $(this);

    const level = $thisEl.data('level');
    const $icon = $thisEl.find('.dms__icon-folder:first');
    const $subelement = $thisEl.children('.dms__level' + (parseInt(level) + 1)).filter(function () {
        return $(this).data('hidden') === false;
    });

    if ($subelement.length) {
        if ($subelement.is(':hidden')) {
            $thisEl.addClass('active');
            $icon.addClass('active');
            $subelement.slideDown();
        } else {
            if (!onlyShow === true) {
                $thisEl.removeClass('active');
                $icon.removeClass('active');
                $subelement.slideUp();
            }
        }
    }
}

export const reloadScriptDms = () => {
    const $dmsEl = $('.dms');

    $dmsEl.each(function () {
        dms($(this));
    });
};
reloadScriptDms();
